export const MARQUEE = 'marquee';

export enum COLOR {
    red = 'red',
    purple = 'purple',
    gold = 'gold',
    navy = 'navy',
    cyan = 'cyan',
}

export enum CTA_ACTIONS {
    linkToPage = 'linkToPage',
    gameLaunch = 'gameLaunch'
}
